import { topProductSlider, topSlider } from './functions/splideSlider';
import { doublePullDown } from './functions/utilityFunctions';

const pullDownButton = document.querySelectorAll('.js-doublePullDown');
const mediaQuery = window.matchMedia('(min-width: 768px)');
const pullDown = (mediaQuery) => {
  let width = window.innerWidth;

  if (pullDownButton.length) {
    pullDownButton.forEach((element) => {
      const targetId = element.getAttribute('data-target');
      const target = document.getElementById(targetId);

      if (!mediaQuery.matches) {
        target.style.height = '106px';
        doublePullDown(element, 106);
      } else {
        target.style.height = 'auto';
      }
    });
  }
};

const handleMediaQuery = (mediaQuery) => {
  pullDown(mediaQuery);
};

/** 話題の商品Map { CategoryCode: [ {TopNewArrivalItem}, {TopNewArrivalItem}, ... ] } */
let newArrivalItems = {};
/** 属性別ランキングMap { sex: { generation: [ {TopAttrRankingItem}, {TopAttrRankingItem}, ... ] }, ... } */
let attrRankingItems = {};
// /** 週間ランキング */
// let weeklyRankingItems = {};

document.addEventListener('DOMContentLoaded', () => {
  topSlider();
  mediaQuery.addEventListener('change', handleMediaQuery);
  handleMediaQuery(mediaQuery);

  // タグ取得API実行
  fetch('/api/toptags')
    .then((data) => data.json())
    .then((res) => {
      const attentionTags = res.t1;
      const newTags = res.t2;
      const newTagList = document.querySelector('#js-newTagList');
      const bigTagList = document.querySelector('#js-bigTagList');
      for (const item of res.t1) {
        newTagList.insertAdjacentHTML('beforeend', `<li><a class="c-tag" href="/tag/?tagid=${item.tagid}">${item.tagname}</a></li>`);
      }
      for (const item of res.t2) {
        bigTagList.insertAdjacentHTML('beforeend', `<li><a class="c-tag" href="/tag/?tagid=${item.tagid}">${item.tagname}</a></li>`);
      }
    });

  // 話題の商品取得API実行
  fetch('/api/topnewarrivalitems')
    .then((data) => data.json())
    .then((res) => {
      newArrivalItems = res;
      document.querySelector('#reservation-category1').click();
    });

  // 話題の商品タブ押下時、カテゴリ切り替え
  const newArrivalTabButton = document.querySelectorAll('.js-tab-newarrival');
  const newArrivalSplide = document.querySelector('#newarrival-splide');

  newArrivalTabButton.forEach((element) => {
    element.addEventListener('click', (e) => {
      newArrivalSplide.innerHTML = '';
      const ctgrycode = e.target.value;
      newArrivalItems[ctgrycode].forEach((item) => {
        let overlayLabelClass = '';
        // ラベル付与
        if (item.reservedFlag === '1') {
          overlayLabelClass = 'l-top__products-img--label-reserve';
        } else if (item.stockFlag === '1') {
          overlayLabelClass = 'l-top__products-img--label-stock';
        }
        newArrivalSplide.insertAdjacentHTML(
          'beforeend',
          `
          <li class="splide__slide l-top__reserve-products-list">
            <a href="/detail/${item.cmdtycode}/" class="l-top__reserve-products-link">
              <span class="l-top__products-date">${item.releaseDateStr}</span>
              <div class="l-top__products-img ${overlayLabelClass} ">
              <img src="${item.imageUrl}" alt="" loading="lazy" />
              </div>
              <span class="l-top__products-name">${item.cmdtytitle}</span>
            </a>
          </li>
          `,
        );
      });
      // スライド初期化
      topProductSlider();
    });
  });

  //   // 週間ランキングタブ押下時、カテゴリ切り替え
  const weeklyRankingRadios = document.querySelectorAll('input[name="ranking-category"]');
  const weeklyRankingSplide = document.querySelector('#weekly-ranking-splide');

  //   weeklyRankingRadios.forEach((ele) => {
  //     ele.addEventListener('click', (e) => {
  //       const ctgrycode = e.target.value;
  //       weeklyRankingSplide.innerHTML = '';
  //       // すでに取得済の場合はそれを使う
  //       if (weeklyRankingItems[ctgrycode]) {
  //         weeklyRankingItems[ctgrycode].forEach((item) => {
  //           weeklyRankingSplide.insertAdjacentHTML(
  //             'beforeend',
  //             `
  //             <li class="splide__slide">
  //               <a href="/detail/${item.cmdtycode}" class="l-top__products-list">
  //                 ${item.rank <= 3 ? `<div class="l-top__ranking l-top__ranking--${item.rank}"></div>` : `<div class="l-top__ranking">${item.rank}位</div>`}
  //                 <div class="l-top__products-img">
  //                   <img src="${item.imageUrl}" alt="" />
  //                 </div>
  //                 <span class="l-top__products-name">${item.title}</span>
  //                 <span class="l-top__products-price">${item.usedpriceStr}円</span>
  //               </a>
  //             </li>
  //             `,
  //           );
  //         });
  //         // スライド初期化
  //         topProductSlider();
  //       } else {
  //         // APIからランキング取得
  //         fetch(`/api/topweeklyranking?ctgryCode=${ctgrycode}`)
  //           .then((data) => data.json())
  //           .then((res) => {
  //             weeklyRankingItems[ctgrycode] = res; // キャッシュ
  //             weeklyRankingItems[ctgrycode].forEach((item) => {
  //               weeklyRankingSplide.insertAdjacentHTML(
  //                 'beforeend',
  //                 `
  //                 <li class="splide__slide">
  //                   <a href="/detail/${item.cmdtycode}" class="l-top__products-list">
  //                     ${item.rank <= 3 ? `<div class="l-top__ranking l-top__ranking--${item.rank}"></div>` : `<div class="l-top__ranking">${item.rank}位</div>`}
  //                     <div class="l-top__products-img">
  //                       <img src="${item.imageUrl}" alt="" />
  //                     </div>
  //                     <span class="l-top__products-name">${item.title}</span>
  //                     <span class="l-top__products-price">${item.usedpriceStr}円</span>
  //                   </a>
  //                 </li>
  //                 `,
  //               );
  //             });
  //             // スライド初期化
  //             topProductSlider();
  //           });
  //       }
  //     });
  //   });

  weeklyRankingRadios.forEach((ele) => {
    ele.addEventListener('click', (e) => {
      const ctgrycode = e.target.value;
      weeklyRankingSplide.innerHTML = '';

      weeklyRanking[ctgrycode].forEach((item) => {
        weeklyRankingSplide.insertAdjacentHTML(
          'beforeend',
          `
            <li class="splide__slide">
            <a href="/detail/${item.cmdtycode}/" class="l-top__products-list">
                ${item.rank <= 3 ? `<div class="l-top__ranking l-top__ranking--${item.rank}"></div>` : `<div class="l-top__ranking">${item.rank}位</div>`}
                <div class="l-top__products-img">
                <img src="${item.imageUrl}" alt="" loading="lazy" />
                </div>
                <span class="l-top__products-name">${item.title}</span>
                <span class="l-top__products-price">${item.usedpriceStr}円</span>
            </a>
            </li>
          `,
        );
      });
      // スライド初期化
      topProductSlider();
    });
  });

  // 週間ランキングAPI実行
  document.querySelector('#ranking-category1').click();

  // 話題の商品取得API実行
  fetch('/api/topattrranking')
    .then((data) => data.json())
    .then((res) => {
      attrRankingItems = res;
      document.querySelector('#man-ranking1').click();
      document.querySelector('#man-ranking-woman1').click();
    });

  // 性別・年代別タブ押下時、ランキング切り替え
  const attrTabButtonsMan = document.querySelectorAll('.js-top__gender-tab--man');
  const attrRankingUlMan = document.querySelector('.js-attr-ranking--man');
  attrTabButtonsMan.forEach((ele) => {
    ele.addEventListener('click', (e) => {
      const sexcode = 1;
      const generation = e.target.value;
      insertAttrRankingElement(sexcode, generation, attrRankingUlMan);
    });
  });

  // 性別・年代別タブ押下時、ランキング切り替え
  const attrTabButtonsWoMan = document.querySelectorAll('.js-top__gender-tab--woman');
  const attrRankingUlWoMan = document.querySelector('.js-attr-ranking--woman');
  attrTabButtonsWoMan.forEach((ele) => {
    ele.addEventListener('click', (e) => {
      const sexcode = 2;
      const generation = e.target.value;
      insertAttrRankingElement(sexcode, generation, attrRankingUlWoMan);
    });
  });

  // クーポン取得ボタン
  const getCoupon = document.querySelectorAll('.js-getcoupon-button');
  getCoupon.forEach((ele) => {
    const couponNo = ele.dataset.value;
    // クーポン取得済の場合はdisabled
    if (document.cookie.includes(`sellcoupon=${couponNo};`)) {
      // ボタン切り替え
      ele.disabled = true;
      ele.innerHTML = 'このクーポンが選択されています';
    }
    ele.addEventListener('click', (e) => {
      document.cookie = 'sellcoupon=;';
      document.cookie = `sellcoupon=${couponNo};path=/;`;

      // ボタンリセット
      getCoupon.forEach((ele) => {
        ele.disabled = false;
        ele.innerHTML = 'このクーポンを使う';
      });
      // ボタン切り替え
      ele.disabled = true;
      ele.innerHTML = 'このクーポンが選択されています';

      // スナックバー表示
      document.getElementById('js-couponNo').innerHTML = couponNo;
      const targetId = ele.getAttribute('data-target');
      const target = document.getElementById(targetId);
      if (target) {
        target.classList.add('is-active');
      }
    });
  });

  // クーポンモーダル開封時、クーポン適応時した時のスナックバーも同時に消す
  const couponSnackBerCloseTarget = document.querySelectorAll('.js-couponSnackBerClose');
  if (couponSnackBerCloseTarget) {
    couponSnackBerCloseTarget.forEach((Close) => {
      Close.addEventListener('click', (e) => {
        const couponModel = document.getElementById('js-couponModal');
        if (couponModel.classList.contains('is-active')) {
          couponModel.classList.remove('is-active');
        }
        const couponSnackTarget = document.getElementById('js-getCoupon');
        if (couponSnackTarget.classList.contains('is-active')) {
          couponSnackTarget.classList.remove('is-active');
        }
      });
    });
  }
});

/**
 * 属性別ランキング切り替え
 */
function insertAttrRankingElement(sexcode, generation, targetElement) {
  targetElement.innerHTML = '';
  if (!attrRankingItems || !attrRankingItems[sexcode] || !attrRankingItems[sexcode][generation] || attrRankingItems[sexcode][generation].length === 0) {
    targetElement.insertAdjacentHTML(
      'beforeend',
      `
        <li>
          <span class="l-top__gender-ranking-list"> 集計中 </span>
        </li>
      `,
    );
    return;
  }
  attrRankingItems[sexcode][generation].forEach((item) => {
    const rankClass = item.rank <= 3 ? `l-top__rank-num--${item.rank}` : '';
    targetElement.insertAdjacentHTML(
      'beforeend',
      `
        <li>
        <a href="/detail/${item.cmdtycode}/" class="l-top__gender-ranking-list">
            <span class="l-top__rank"><span class="l-top__rank-num ${rankClass}">${item.rank}</span>位</span>
            <span class="l-top__gender-product"> ${item.title} </span>
        </a>
        </li>
      `,
    );
  });
}
